module.exports = __webpack_public_path__ + "static/media/wd.55643599.jpeg";